import React from "react";

export interface CardPeriodProps {
  startDate?: string;
  endDate?: string;
  isActive: boolean;
  onPurchase?: () => void;
  className?: string;
}

const CardPeriod: React.FC<CardPeriodProps> = ({
  startDate,
  endDate,
  isActive,
  onPurchase,
  className = "",
}) => {
  if (isActive && startDate && endDate) {
    // Active state with gradient background
    return (
      <div
        className={`
          bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa]
          rounded-[8px] px-4 py-5
          flex items-center justify-between
          w-full min-w-[328px] max-w-[800px]
          ${className}
        `}
      >
        <p className="font-medium text-[14px] leading-[20px] tracking-[-0.28px] text-white whitespace-nowrap">
          이용기간
        </p>
        <p className="font-bold text-[16px] leading-[24px] tracking-[-0.32px] text-white text-right whitespace-nowrap">
          {startDate} ~ {endDate}
        </p>
      </div>
    );
  }

  // Inactive state with border and gradient text
  return (
    <div
      className={`
        border border-[#cd3ec7] rounded-[8px] px-4 py-5
        flex items-center justify-between
        w-full min-w-[328px] max-w-[800px]
        ${className}
      `}
    >
      <div className="flex flex-col">
        <p className="font-bold text-[16px] leading-[24px] tracking-[-0.32px] bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa] bg-clip-text text-transparent">
          과학동아AiR PASS{" "}
          <span className="font-medium">구매하고,</span>
        </p>
        <p className="font-bold text-[16px] leading-[24px] tracking-[-0.32px] bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa] bg-clip-text text-transparent">
          자유롭게 이용<span className="font-medium">하세요!</span>
        </p>
      </div>

      <button
        type="button"
        onClick={onPurchase}
        className="
          bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa]
          h-10 px-5 rounded-[8px]
          flex items-center justify-center
          hover:opacity-90 transition-opacity
        "
      >
        <span className="font-bold text-[14px] leading-[20px] tracking-[-0.28px] text-white whitespace-nowrap">
          구매하기
        </span>
      </button>
    </div>
  );
};

export default CardPeriod;
